import { Controller } from "@hotwired/stimulus";
import SlimSelect from "slim-select";

// Connects to data-controller="slim-select"
export default class extends Controller {
  static targets = ["select", "selectToFilter"];

  static values = { itemId: String, orderId: String, mode: String };

  declare selectTarget: HTMLSelectElement;
  declare hasSelectTarget: boolean;
  declare selectToFilterTarget: HTMLSelectElement;
  declare hasSelectToFilterTarget: boolean;
  declare itemIdValue: string;
  declare hasItemIdValue: boolean;
  declare orderIdValue: string;
  declare hasOrderIdValue: boolean;
  declare modeValue: string;
  declare hasModeValue: boolean;

  connect() {
    if (this.hasSelectTarget) {
      let select = new SlimSelect({
        select: this.selectTarget,
        settings: {
          searchPlaceholder: "Rechercher",
          searchText: "Aucun résultat",
        },
        events: {
          afterChange: () => {
            const urlWithoutParams = window.location.toString().split("?")[0];
            if (this.hasItemIdValue || this.hasOrderIdValue) {
              if (this.hasModeValue && this.modeValue == "team") {
                if (this.hasItemIdValue) {
                  document.location.href = `${urlWithoutParams}?item_id=${this.itemIdValue}&team_id=${
                    select.getSelected()[0]
                  }`;
                } else if (this.hasOrderIdValue) {
                  document.location.href = `${urlWithoutParams}?order_id=${this.orderIdValue}&team_id=${
                    select.getSelected()[0]
                  }`;
                }
              } else {
                if (this.hasItemIdValue) {
                  document.location.href = `${urlWithoutParams}?item_id=${this.itemIdValue}&type=individual&user_id=${
                    select.getSelected()[0]
                  }`;
                } else if (this.hasOrderIdValue) {
                  document.location.href = `${urlWithoutParams}?order_id=${this.orderIdValue}&type=individual&user_id=${
                    select.getSelected()[0]
                  }`;
                }
              }
            } else if (this.hasSelectToFilterTarget) {
              if (this.hasModeValue && this.modeValue == "slotItem") {
                const itemId = select.getSelected()[0];
                Array.from(this.selectToFilterTarget.options).forEach((element) => {
                  if (element.value == "" || element.dataset.itemId == itemId) {
                    element.classList.remove("hidden");
                  } else {
                    element.classList.add("hidden");
                    if (element.selected) {
                      element.selected = false;
                    }
                  }
                });
              }
            }
          },
        },
      });
    }
  }
}
